import moment from "moment";
import React, { useCallback, useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { MdClear } from "react-icons/md";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { ReactComponent as Package } from "../../../../../assets/images/route-detail/package.svg";
import { Loading } from "../../../../../components/Loading";
import ShippingStagesEnum from "../../../../../enums/ShippingStagesEnum";
import { BrComerceApiService } from "../../../../../services/BrComerceApiService";
import store from "../../../../../store/store";
import debounce from "../../../../../utils/debounce";
import useGetWindowWidth from "../../../../../utils/useGetWindowWidth";
import { CartCardShipping } from "../../../components/CartCardShipping";
import Container from "../../../components/Container";

import { FiAlertTriangle, FiChevronLeft, FiChevronRight, FiSearch } from "react-icons/fi";
import { GoogleMapsRoute } from "../../../../../components/GoogleMapsRoute";
import pinTruck from "../../../../../assets/icons/pin-truck.svg";
import styles from "./styles.module.scss";
import { addressInfoHandled } from "../../../../../utils/handleAddress";

const RouteDetail = () => {
  window.setPageTitle("Detalhes da Rota");

  const api = new BrComerceApiService();
  const params = useParams();
  const { auth } = store.getState();
  const { user } = auth;
  const widthWindows = useGetWindowWidth();
  const [loading, setLoading] = useState(false);
  const [route, setRoute] = useState([]);
  const [shippings, setShippings] = useState([]);
  const [shippingsExpand, setShippingsExpand] = useState([]);
  const [search, setSearch] = useState("");
  const [amountRouteShippings, setAmountRouteShippings] = useState(0);

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const [locations, setLocations] = useState([]);
  const [packageslocations, setPackagesLocations] = useState([]);

  const coordinatesRJ = {
    lat: -22.9035,
    lng: -43.2096
  };


  const handleClearSearchFilter = () => {
    setSearch("");
  };

  const loadShippingsByRoute = useCallback(async (search, page) => {
    const fetchData = async (search, page) => {
      try {
        setLoading(true);
        const response = await api.makeHttpRequest({
          method: "GET",
          url: `route-admin/${params.id}`,
          params: {
            page: search ? 1 : page,
            resultsPerPage: 20,
            ...(search && { text: search })
          }
        });

        const route = response?.route

        setRoute(route);
        setShippings(response?.listPackages);
        setPage(response?.routePackages?.actualPage);
        setTotalPages(
          response?.routePackages?.nPage === 0
            ? 1
            : response?.routePackages?.nPage
        );
        setAmountRouteShippings(response?.routePackages?.amount);
        handleLocations(response?.listLocation, "driver_route");
        const packages = response?.listPackages
        if (packages?.length && route?.origin_destination) {
          const formatedOrigin = handleOriginDestinationToLocation(route?.origin_destination?.origin, "Origem")
          const formatedDestination = handleOriginDestinationToLocation(route?.origin_destination?.destination, "Destino")
          const formatedPackages = handlePackagesToLocation(packages)
          handleLocations([formatedOrigin, ...formatedPackages, formatedDestination], "packages");
        }
      } catch (e) {
        setLoading(false);
        Swal.fire({
          icon: "error",
          title: "Erro",
          text:
            "Houve um erro ao carregar a página, tente novamente mais tarde."
        });
        console.error("Houve um erro ao carregar a página", JSON.stringify(e));
      } finally {
        setLoading(false);
      }
    }

    if (search && search.length > 2) {
      const debounced = debounce(fetchData, 1800);
      debounced(search, page)
    } else {
      await fetchData(search, page)
    }
  },
    [search, page]
  );

  const handlePackagesToLocation = (packages) => {
    const locations = packages.map(p => {
      const isOwnCollect = !!p?.ownCollect;
      const pack = isOwnCollect ? p?.ownCollect : p?.shipping;
      const addressData = isOwnCollect ? pack?.collectAddress : pack?.destination;

      let finalAddress = addressData?.street;

      if (!!addressData?.number) {
        finalAddress += `, ${addressData?.number}`;
      }

      if (!!addressData?.complement) {
        finalAddress += `, ${addressData?.complement}`;
      }

      if (!!addressData?.district) {
        finalAddress += `, ${addressData?.district}`;
      }

      return {
        latitude: addressData?.location?.lat,
        longitude: addressData?.location?.lng,
        order: p?.order,
        client: addressData?.name,
        client_email: addressData?.emailUser,
        client_phone: addressData?.phone,
        status: p?.id_own_delivery_status,
        delivered_in_another_route: p?.delivered_in_another_route,
        delivered_at_route_id: p?.delivered_at_route_id,
        type: pack?.type,
        ...(pack?.sro && { sro: pack?.sro }),
        id: pack?.id,
        address: finalAddress,
        distance: p?.distance,
        realized_date: p?.delivery?.delivery_date,
        ...(pack?.collectTimeStart && { startHour: pack?.collectTimeStart }),
        ...(pack?.collectTimeEnd && { endHour: pack?.collectTimeEnd }),
        isOwnCollect
      }

    })

    return locations
  }

  const handleOriginDestinationToLocation = (originDestination, type) => {
    return {
      isOriginDestination: true,
      latitude: originDestination?.latitude,
      longitude: originDestination?.longitude,
      address: originDestination?.address,
      origin_or_destination: type
    }
  }

  const onChangePagination = type => {
    setLoading(true);

    if (type === "next") {
      setPage(page + 1);
    } else {
      setPage(page - 1);
    }
  };

  const handleShippingExpand = useCallback(
    pack => {
      const find = shippingsExpand.find(p => p.id === pack.id);
      if (find) {
        const newPacks = shippingsExpand.filter(p => p.id !== pack.id);
        setShippingsExpand([...newPacks]);
      } else {
        shippingsExpand.push(pack);
        setShippingsExpand([...shippingsExpand]);
      }
    },
    [shippingsExpand]
  );

  const handleStatusColor = value => {
    const status = {
      "A Fazer": "#C1C1C1",
      "Em Andamento": "#F5CB2B",
      Concluída: "#409e6a"
    };

    return status[value];
  };

  const handleLocations = (value, type) => {
    const handledGeolocations = []
    if (value?.length) {
      value.forEach(item => {
        if (item && item?.latitude && item?.longitude) {
          handledGeolocations.push({
            lat: Number(item?.latitude),
            lng: Number(item?.longitude),
            ...(item?.order?.toString() && { order: item.order }),
            ...(item?.client && { client: item.client }),
            ...(item?.sro && { sro: item.sro }),
            ...(item?.client_email && { client_email: item.client_email }),
            ...(item?.client_phone && { client_phone: item.client_phone }),
            ...(item?.status && { status: item.status }),
            ...(item?.delivered_in_another_route !== undefined && { delivered_in_another_route: item.delivered_in_another_route }),
            ...(item?.delivered_at_route_id !== undefined && { delivered_at_route_id: item.delivered_at_route_id }),
            ...(item?.type && { type: item.type }),
            ...(item?.address && { address: item.address }),
            ...(item?.distance && { distance: item.distance }),
            ...(item?.isOriginDestination && { isOriginDestination: item.isOriginDestination }),
            ...(item?.origin_or_destination && { origin_or_destination: item.origin_or_destination }),
            ...(item?.startHour && { startHour: item.startHour }),
            ...(item?.endHour && { endHour: item.endHour }),
            ...(item?.id && { id: item.id }),
            ...(item?.isOwnCollect && { isOwnCollect: item.isOwnCollect }),
            ...(item?.realized_date && { realized_date: item.realized_date }),
          });
        }
      });
    }

    const locations = {
      packages: () => setPackagesLocations(handledGeolocations),
      driver_route: () => setLocations(handledGeolocations)
    }

    locations[type]()
  };

  useEffect(() => {
    (async () => {
      await loadShippingsByRoute(search, page);
    })();
  }, [search, page, loadShippingsByRoute]);

  const displayMap = !loading && (!!locations?.length || !!packageslocations?.length);

  return (
    <>
      <Loading loading={loading} />
      <Container title={`Rota n° ${route?.id ?? "--"}`}>
        <div className={`${styles.inputContainer}`}>
          <div className={styles.input}>
            <input
              type="text"
              name="search"
              placeholder="Busque pelo código da etiqueta, nome do remetente ou destinatário"
              onChange={e => setSearch(e.target.value)}
              value={search}
            />
            {!search.length && <FiSearch size={20} color="#409e6a" />}
            {!!search?.length && (
              <MdClear
                style={{ cursor: "pointer" }}
                onClick={handleClearSearchFilter}
              />
            )}
          </div>
        </div>
        {!loading && !!route?.id && !route?.routing && (
          <div className={styles.unorderedAlert}>
            <FiAlertTriangle size={22} />
            <div>
              <strong>Esta rota não foi ordenada</strong>
              <p>
                A otimização falhou e as paradas estão sem ordem definida. Em geral isso acontece
                quando algum envio da rota está com o endereço geolocalizado fora da área — confira
                os endereços, remova o envio problemático e crie a rota novamente.
              </p>
            </div>
          </div>
        )}
        {window.screen.width > 480 ?
          <Row style={{ margin: "32px 0", width: "100%" }} className={styles.cardInfo}>
            <Col xs={6} className="pl-0">
              <div className={`${styles.card} ${styles.cardTotal}`}>
                <div className={styles.information}>
                  <h3>Total de objetos</h3>
                  <h1>{amountRouteShippings} {amountRouteShippings > 1 ? "envios" : "envio"}</h1>
                </div>
                <div className={styles.informationImage}>
                  <Package />
                </div>
              </div>
            </Col>
            <Col xs={6} className="pr-0">
              <div className={`${styles.card} ${styles.cardRoute}`}>
                <div className={styles.cardHeader}>
                  <h4>SOBRE A ROTA</h4>
                </div>
                <div className={styles.cardBody}>
                  <div>
                    <span>
                      Criada em{" "}
                      <label>
                        {moment(route?.created_at).format("DD/MM/YYYY")}
                      </label>
                    </span>
                  </div>
                  <div>
                    <span>
                      Status:{" "}
                      <label
                        style={{ color: handleStatusColor(route?.status?.name) }}
                      >
                        {route?.status?.name || "--"}
                      </label>
                    </span>
                  </div>
                  <div>
                    <span>
                      Motorista: <label>{route?.driver?.name || "--"}</label>
                    </span>
                  </div>
                  <div>
                    <span>
                      Início: <label>{
                        route?.started_at ?
                          moment(route?.started_at).format("DD/MM/YYYY - HH:mm")
                          : "--"
                      }</label>
                    </span>
                  </div>
                  <div>
                    <span>
                      Fim: <label>{
                        route?.finalized_at ?
                          moment(route?.finalized_at).format("DD/MM/YYYY - HH:mm")
                          : "--"
                      }</label>
                    </span>
                  </div>
                  <div>
                    <span>
                      Kms Percorrido: <label>{route?.kms_traccar ? `~ ${route?.kms_traccar?.toFixed(2)} km` : "--"}</label>
                    </span>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
          :
          <Row style={{
            display: "flex",
            alignSelf: "center",
            margin: "32px 0",
            width: "90%",
            gap: "12px"
          }} className={styles.cardInfo}>
            <Row xs={1} className="pl-0">
              <div className={`${styles.card} ${styles.cardTotal}`}>
                <div className={styles.information}>
                  <h3>Total de objetos</h3>
                  <h1>{amountRouteShippings} {amountRouteShippings > 1 ? "envios" : "envio"}</h1>
                </div>
                <div className={styles.informationImage}>
                  <Package />
                </div>
              </div>
            </Row>
            <Row xs={1} className="pr-0">
              <div className={`${styles.card} ${styles.cardRoute}`}>
                <div className={styles.cardHeader}>
                  <h4>SOBRE A ROTA</h4>
                </div>
                <div className={styles.cardBody}>
                  <div>
                    <span>
                      Criada em{" "}
                      <label>
                        {moment(route?.created_at).format("DD/MM/YYYY")}
                      </label>
                    </span>
                  </div>
                  {/* <div>
                    <span>
                      Contém <label>{amountRouteShippings} envios</label>
                    </span>
                  </div> */}
                  <div>
                    <span>
                      Status:{" "}
                      <label
                        style={{ color: handleStatusColor(route?.status?.name) }}
                      >
                        {route?.status?.name || "--"}
                      </label>
                    </span>
                  </div>
                  <div>
                    <span>
                      Motorista: <label>{route?.driver?.name || "--"}</label>
                    </span>
                  </div>
                  <div>
                    <span>
                      Início: <label>{
                        route?.started_at ?
                          moment(route?.started_at).format("DD/MM/YYYY - HH:mm")
                          : "--"
                      }</label>
                    </span>
                  </div>
                  <div>
                    <span>
                      Fim: <label>{
                        route?.finalized_at ?
                          moment(route?.finalized_at).format("DD/MM/YYYY - HH:mm")
                          : "--"
                      }</label>
                    </span>
                  </div>
                  <div>
                    <span>
                      Kms Percorrido: <label>{route?.kms_traccar ? `~ ${route?.kms_traccar?.toFixed(2)} km` : "--"}</label>
                    </span>
                  </div>
                </div>
              </div>
            </Row>
          </Row>
        }
        {displayMap &&
          <Row style={{ margin: "32px 0", width: "100%" }}>
            <Col className={styles.mapWrapper} xs={12}>
              <GoogleMapsRoute
                mapContext="routeDetails"
                zoom={15}
                centralizeCoordinates={coordinatesRJ}
                locations={locations}
                packages={packageslocations}
                iconMarker={pinTruck}
                visibleToggle={true}
                hasDetailsRoute
              />
            </Col>
          </Row>
        }
        <div className={styles.collectWrapper}>
          {!!shippings?.length ? (
            shippings?.map(pack => {
              return (
                <CartCardShipping
                  widthWindows={widthWindows}
                  key={pack?.shipping?.id || pack?.ownCollect?.id}
                  shipping={pack?.ownCollect || pack?.shipping}
                  isSelected={false}
                  isCancelled={
                    pack?.shipping?.idShippingStatus ===
                    ShippingStagesEnum.OBJETO_CANCELADO.id
                  }
                  isExpand={shippingsExpand.find(
                    shipExpand => pack.id === shipExpand.id
                  )}
                  onExpand={() => handleShippingExpand(pack)}
                  onClick={() => { }}
                  setLoading={setLoading}
                  removeShipping={() => { }}
                  isAdmin={user.profile === "admin"}
                  invoiceMethod={"null"}
                  collectStage={4}
                  edit={false}
                  linkTracking
                  select={false}
                  delivery={pack?.delivery ?? {}}
                  status={true}
                  order={pack.order}
                />
              );
            })
          ) : (
            <div className={styles.notFoundOrEmptyContainer}>
              <p>
                {!shippings?.length && !!search
                  ? "Não foram encontradas envios para essa pesquisa."
                  : "Ainda não há envios para essa Rota."}
              </p>
            </div>
          )}

          <div className={styles.pagination} style={{ marginBottom: 60 }}>
            <h6>
              Página {page} de {totalPages}
            </h6>
            <div>
              {page > 1 && (
                <FiChevronLeft
                  onClick={() => onChangePagination("previous")}
                  className="arrow"
                />
              )}
              {totalPages > 1 && <h6>{page}</h6>}
              {page < totalPages && (
                <FiChevronRight
                  onClick={() => onChangePagination("next")}
                  className="arrow"
                />
              )}
            </div>
          </div>
        </div>
      </Container>
    </>
  );
};

export { RouteDetail };
